import { apiGetExternal, ApiResponse } from './apiFactory'
import {
  ScorecardSummaryResponseSchema,
  deserializeScorecardSummaryData,
  ScorecardSummaryData,
} from 'data/scorecardSummary'
import { driverPerformanceApi } from './driverPerformanceApi'

export async function getDriverScorecardSummary(profileId: number): Promise<ApiResponse<ScorecardSummaryData>> {
  return await apiGetExternal(
    driverPerformanceApi,
    `/api/v1/scorecard-summary?profile_id=${profileId}`,
    ScorecardSummaryResponseSchema,
    deserializeScorecardSummaryData
  )
}
